import { $body, BrowserEvents, loadingBar } from './constants';
import bootbox from 'bootbox';

;(function($) {

	$(document).on(BrowserEvents.barba.enter, function() {

		// ---------- Sections ----------

		$('.images-carousel-section .slideshow').each(function() {

			const self = $(this);

			const settings = {
				infinite: true,
				arrows: true,
				autoplay: true,
				autoplaySpeed: 5000,
				pauseOnFocus: false,
				pauseOnHover: false,
				speed: 1500,
				slidesToShow: 1,
				centerMode: true,
				centerPadding: '0'
			};

			self.on('init reInit beforeChange afterChange', function() {
				$(window).trigger(BrowserEvents.lazyload);
			});

			if(!self.hasClass('slick-initialized')) {
				self.slick(settings);
			}
		});

		$('.simple-map').each(function() {

			if(this.dataset.lat && this.dataset.lng) {

				const init_map = () => {

					const markerLatLng = new google.maps.LatLng(this.dataset.lat, this.dataset.lng);

					const mapOptions = {
						zoom: 15,
						mapTypeId: 'hybrid',
						mapTypeControl: false,
						scrollwheel: false,
						center: markerLatLng,
					};

					const mapElement = this;

					const map = new google.maps.Map(mapElement, mapOptions);

					const marker = new google.maps.Marker({
						position: markerLatLng,
						map: map,
					});
				}

				if(typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
					init_map();
				}
				else {
					$(window).on('load', init_map);
				}
			}
		});

		$body.on('adding_to_cart', function(e, button, cart) {

			loadingBar.classList.add('active');

			$body.one('added_to_cart', () => {

				loadingBar.classList.remove('active');

				if(typeof added_to_cart_modal !== 'undefined') {

					bootbox.dialog({
						centerVertical: true,
						className: 'cart-modal',
						closeButton: false,
						message: added_to_cart_modal.content,
					});
				}

				if(cart.length) {
					const quantity = cart.find(item => item.name === 'quantity');

					if(quantity) {
						const link = $('.header-shop-links .cart span');
						const current = parseInt(link.text());
						link.text(current + parseInt(quantity.value));
					}
				}
			});
		});

		$('.swatch_wrapper.pa_millesime .wcvs-swatch.selected').each(function() {
			$('.product-vintage-description-' + this.dataset.value).addClass('active');
		});

		$(document).on('show_variation', (event, variation) => {
			$('.product-vintage-description').removeClass('active');
			$('.product-vintage-description-' + variation.attributes.attribute_pa_millesime).addClass('active');
		});

	});

}(jQuery));
